/**
 * Detail payload for the `o2d-tab-list.selected` event.
 * Dispatched from user interaction only (click handler + keyboard controller),
 * carrying the id of the newly active tab. Never dispatched from a reactive
 * lifecycle hook or a property setter (loop-safety on external `activeId` set).
 */
export interface TabSelectedDetail {
    id: string;
}

/** Event name constant for the tab-selected event. */
export const O2D_TAB_LIST_SELECTED = 'o2d-tab-list.selected' as const;
